import styles from "exports.module.scss";
import { ReactComponentElement } from "react";

import { Box } from "@seneca/senekit";

type Props = {
  children: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
};

export default function ParentDashboardLayout({ children }: Props) {
  return (
    <Box
      width="100vw"
      maxWidth="100%"
      minHeight={`calc(100vh - ${styles.navbarHeight})`}
      height="100%"
      display="flex"
      justifyContent="center"
    >
      <Box
        width={styles.maxContentWidth}
        minHeight={`calc(100vh - ${styles.navbarHeight})`}
        height="100%"
        display="flex"
        justifyContent="center"
      >
        {children}
      </Box>
    </Box>
  );
}
